import { useAtom } from 'jotai';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { BIZ_MESSAGE_REQUEST_TYPES } from '@/lib/constants/variables';
import { bizMessageTypeAtom } from '@/lib/stores/biz-message';
import { BizMessageRequestType } from '@/lib/types/auth';

export const useBizMessageRequestType = () => {
  const router = useRouter();

  const [requestType, setRequestType] = useAtom(bizMessageTypeAtom);
  const [isSetRequestType, setIsSetRequestType] = useState(false);

  useEffect(() => {
    if (router.isReady) {
      const { type } = router.query;
      if (type && BIZ_MESSAGE_REQUEST_TYPES.includes(type as string)) {
        setRequestType(type as BizMessageRequestType);
      }
      setIsSetRequestType(true);
    }
  }, [router.isReady, router.query, setRequestType]);

  return { requestType, isSetRequestType };
};
